import SimpleParallax from 'simple-parallax-js';

const CONFIG = {
  overflow: true,
  scale: 2,
};

export default function () {
  const particles = document.querySelectorAll('[class*="ico-particle"]');
  const waterdrops = document.querySelectorAll('[class*="ico-waterdrop"]');

  if (!particles.length || !waterdrops.length) {
    return;
  }

  const items = [particles, waterdrops];

  items.forEach((e) => new SimpleParallax(e, CONFIG));
}
